// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file common/v3/icons.proto (package common.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv1";
import { file_common_v3_common } from "./common_pb";

/**
 * Describes the file common/v3/icons.proto.
 */
export const file_common_v3_icons: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common]);

/**
 * @generated from enum common.v3.Icon
 */
export enum Icon {
  /**
   * Default icon
   *
   * @generated from enum value: ICON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Basic UI icons
   *
   * @generated from enum value: ICON_AGENT = 1;
   */
  AGENT = 1,

  /**
   * @generated from enum value: ICON_ARROWS_IN = 2;
   */
  ARROWS_IN = 2,

  /**
   * @generated from enum value: ICON_AT_SYMBOL = 3;
   */
  AT_SYMBOL = 3,

  /**
   * @generated from enum value: ICON_AVATAR = 4;
   */
  AVATAR = 4,

  /**
   * @generated from enum value: ICON_BELL = 5;
   */
  BELL = 5,

  /**
   * @generated from enum value: ICON_BELL_ALERT = 6;
   */
  BELL_ALERT = 6,

  /**
   * @generated from enum value: ICON_BELL_SLASH = 7;
   */
  BELL_SLASH = 7,

  /**
   * @generated from enum value: ICON_BELL_SNOOZE = 8;
   */
  BELL_SNOOZE = 8,

  /**
   * @generated from enum value: ICON_BOARD = 9;
   */
  BOARD = 9,

  /**
   * @generated from enum value: ICON_BOOKMARK = 10;
   */
  BOOKMARK = 10,

  /**
   * @generated from enum value: ICON_BUILDING = 11;
   */
  BUILDING = 11,

  /**
   * @generated from enum value: ICON_BULLHORN = 12;
   */
  BULLHORN = 12,

  /**
   * @generated from enum value: ICON_CHART = 13;
   */
  CHART = 13,

  /**
   * @generated from enum value: ICON_CHAT = 14;
   */
  CHAT = 14,

  /**
   * @generated from enum value: ICON_CHATS = 15;
   */
  CHATS = 15,

  /**
   * @generated from enum value: ICON_CHECK = 16;
   */
  CHECK = 16,

  /**
   * @generated from enum value: ICON_CHEVRON_DOWN = 17;
   */
  CHEVRON_DOWN = 17,

  /**
   * @generated from enum value: ICON_CHEVRON_LEFT = 18;
   */
  CHEVRON_LEFT = 18,

  /**
   * @generated from enum value: ICON_CHEVRON_RIGHT = 19;
   */
  CHEVRON_RIGHT = 19,

  /**
   * @generated from enum value: ICON_CHEVRON_UP = 20;
   */
  CHEVRON_UP = 20,

  /**
   * @generated from enum value: ICON_CHEVRON_UP_DOWN = 21;
   */
  CHEVRON_UP_DOWN = 21,

  /**
   * @generated from enum value: ICON_CLIPBOARD = 22;
   */
  CLIPBOARD = 22,

  /**
   * @generated from enum value: ICON_CLOCK = 23;
   */
  CLOCK = 23,

  /**
   * @generated from enum value: ICON_DOCUMENT = 24;
   */
  DOCUMENT = 24,

  /**
   * @generated from enum value: ICON_DOCUMENT_STACK = 25;
   */
  DOCUMENT_STACK = 25,

  /**
   * @generated from enum value: ICON_DOCUMENTATION = 26;
   */
  DOCUMENTATION = 26,

  /**
   * @generated from enum value: ICON_DOT_SEPARATOR = 27;
   */
  DOT_SEPARATOR = 27,

  /**
   * @generated from enum value: ICON_ENVELOPE = 28;
   */
  ENVELOPE = 28,

  /**
   * @generated from enum value: ICON_EXCLAMATION_CIRCLE = 29;
   */
  EXCLAMATION_CIRCLE = 29,

  /**
   * @generated from enum value: ICON_EXCLAMATION_TRIANGLE = 30;
   */
  EXCLAMATION_TRIANGLE = 30,

  /**
   * @generated from enum value: ICON_EXPAND = 31;
   */
  EXPAND = 31,

  /**
   * @generated from enum value: ICON_EXPORT = 32;
   */
  EXPORT = 32,

  /**
   * @generated from enum value: ICON_EYE = 33;
   */
  EYE = 33,

  /**
   * @generated from enum value: ICON_FILE = 34;
   */
  FILE = 34,

  /**
   * @generated from enum value: ICON_FOLDER = 35;
   */
  FOLDER = 35,

  /**
   * @generated from enum value: ICON_HASH = 36;
   */
  HASH = 36,

  /**
   * @generated from enum value: ICON_HYBRID_KNOWLEDGE = 37;
   */
  HYBRID_KNOWLEDGE = 37,

  /**
   * @generated from enum value: ICON_INFORMATION = 38;
   */
  INFORMATION = 38,

  /**
   * @generated from enum value: ICON_INTEGRATION = 39;
   */
  INTEGRATION = 39,

  /**
   * @generated from enum value: ICON_INTERNAL_KNOWLEDGE = 40;
   */
  INTERNAL_KNOWLEDGE = 40,

  /**
   * @generated from enum value: ICON_JOBS = 41;
   */
  JOBS = 41,

  /**
   * @generated from enum value: ICON_LIBRARY = 42;
   */
  LIBRARY = 42,

  /**
   * @generated from enum value: ICON_LIGHT_BULB = 43;
   */
  LIGHT_BULB = 43,

  /**
   * @generated from enum value: ICON_LIGHTNING = 44;
   */
  LIGHTNING = 44,

  /**
   * @generated from enum value: ICON_LIST = 45;
   */
  LIST = 45,

  /**
   * @generated from enum value: ICON_LOCK = 46;
   */
  LOCK = 46,

  /**
   * @generated from enum value: ICON_LOCK_CLOSED = 47;
   */
  LOCK_CLOSED = 47,

  /**
   * @generated from enum value: ICON_MAP_PIN = 48;
   */
  MAP_PIN = 48,

  /**
   * @generated from enum value: ICON_MINIMAL_NAV = 49;
   */
  MINIMAL_NAV = 49,

  /**
   * @generated from enum value: ICON_NAVIGATE = 50;
   */
  NAVIGATE = 50,

  /**
   * @generated from enum value: ICON_NEXT = 51;
   */
  NEXT = 51,

  /**
   * @generated from enum value: ICON_PAPERCLIP = 52;
   */
  PAPERCLIP = 52,

  /**
   * @generated from enum value: ICON_PAUSE = 53;
   */
  PAUSE = 53,

  /**
   * @generated from enum value: ICON_PLAY = 54;
   */
  PLAY = 54,

  /**
   * @generated from enum value: ICON_PLUS = 55;
   */
  PLUS = 55,

  /**
   * @generated from enum value: ICON_PREVIOUS = 56;
   */
  PREVIOUS = 56,

  /**
   * @generated from enum value: ICON_PROMPT = 57;
   */
  PROMPT = 57,

  /**
   * @generated from enum value: ICON_QUESTION_MARK = 58;
   */
  QUESTION_MARK = 58,

  /**
   * @generated from enum value: ICON_REDO = 59;
   */
  REDO = 59,

  /**
   * @generated from enum value: ICON_SEARCH = 60;
   */
  SEARCH = 60,

  /**
   * @generated from enum value: ICON_SETTINGS = 61;
   */
  SETTINGS = 61,

  /**
   * @generated from enum value: ICON_SHARE = 62;
   */
  SHARE = 62,

  /**
   * @generated from enum value: ICON_SLASH_IN_BOX = 63;
   */
  SLASH_IN_BOX = 63,

  /**
   * @generated from enum value: ICON_SPARKLES = 64;
   */
  SPARKLES = 64,

  /**
   * @generated from enum value: ICON_STAR = 65;
   */
  STAR = 65,

  /**
   * @generated from enum value: ICON_STOP = 66;
   */
  STOP = 66,

  /**
   * @generated from enum value: ICON_SYNC = 67;
   */
  SYNC = 67,

  /**
   * @generated from enum value: ICON_TILDE = 68;
   */
  TILDE = 68,

  /**
   * @generated from enum value: ICON_TRASH = 69;
   */
  TRASH = 69,

  /**
   * @generated from enum value: ICON_UNDO = 70;
   */
  UNDO = 70,

  /**
   * @generated from enum value: ICON_USER = 71;
   */
  USER = 71,

  /**
   * @generated from enum value: ICON_WARNING = 72;
   */
  WARNING = 72,

  /**
   * @generated from enum value: ICON_WORKFLOW = 73;
   */
  WORKFLOW = 73,

  /**
   * @generated from enum value: ICON_WORKSPACES = 74;
   */
  WORKSPACES = 74,

  /**
   * @generated from enum value: ICON_WORLD = 75;
   */
  WORLD = 75,

  /**
   * @generated from enum value: ICON_WORLD_KNOWLEDGE = 76;
   */
  WORLD_KNOWLEDGE = 76,

  /**
   * @generated from enum value: ICON_X_MARK = 77;
   */
  X_MARK = 77,

  /**
   * @generated from enum value: ICON_FEEDBACK = 78;
   */
  FEEDBACK = 78,

  /**
   * @generated from enum value: ICON_GIFT = 79;
   */
  GIFT = 79,

  /**
   * Intent-based icons
   *
   * @generated from enum value: ICON_ANALYSIS = 80;
   */
  ANALYSIS = 80,

  /**
   * @generated from enum value: ICON_COMPARISON = 81;
   */
  COMPARISON = 81,

  /**
   * @generated from enum value: ICON_INVESTIGATION = 82;
   */
  INVESTIGATION = 82,

  /**
   * @generated from enum value: ICON_AUDIT = 83;
   */
  AUDIT = 83,

  /**
   * @generated from enum value: ICON_REPORTING = 84;
   */
  REPORTING = 84,

  /**
   * @generated from enum value: ICON_MONITORING = 85;
   */
  MONITORING = 85,

  /**
   * @generated from enum value: ICON_FORECASTING = 86;
   */
  FORECASTING = 86,

  /**
   * @generated from enum value: ICON_DIAGNOSIS = 87;
   */
  DIAGNOSIS = 87,

  /**
   * @generated from enum value: ICON_PRODUCT_USAGE = 88;
   */
  PRODUCT_USAGE = 88,

  /**
   * @generated from enum value: ICON_FEATURE_EXPLANATION = 89;
   */
  FEATURE_EXPLANATION = 89,

  /**
   * @generated from enum value: ICON_HOW_TO = 90;
   */
  HOW_TO = 90,

  /**
   * @generated from enum value: ICON_BEST_PRACTICES = 91;
   */
  BEST_PRACTICES = 91,

  /**
   * @generated from enum value: ICON_TUTORIAL = 92;
   */
  TUTORIAL = 92,

  /**
   * @generated from enum value: ICON_EXAMPLE = 93;
   */
  EXAMPLE = 93,

  /**
   * @generated from enum value: ICON_WORKFLOW_GUIDANCE = 94;
   */
  WORKFLOW_GUIDANCE = 94,

  /**
   * @generated from enum value: ICON_SHORTCUT = 95;
   */
  SHORTCUT = 95,

  /**
   * @generated from enum value: ICON_CREATION = 96;
   */
  CREATION = 96,

  /**
   * @generated from enum value: ICON_TRANSFORMATION = 97;
   */
  TRANSFORMATION = 97,

  /**
   * @generated from enum value: ICON_SYNTHESIS = 98;
   */
  SYNTHESIS = 98,

  /**
   * @generated from enum value: ICON_OPTIMIZATION = 99;
   */
  OPTIMIZATION = 99,

  /**
   * @generated from enum value: ICON_DESIGN = 100;
   */
  DESIGN = 100,

  /**
   * @generated from enum value: ICON_PROTOTYPING = 101;
   */
  PROTOTYPING = 101,

  /**
   * @generated from enum value: ICON_TEMPLATE = 102;
   */
  TEMPLATE = 102,

  /**
   * @generated from enum value: ICON_TASK = 103;
   */
  TASK = 103,

  /**
   * @generated from enum value: ICON_PROCESS = 104;
   */
  PROCESS = 104,

  /**
   * @generated from enum value: ICON_AUTOMATION = 105;
   */
  AUTOMATION = 105,

  /**
   * @generated from enum value: ICON_DEPLOYMENT = 106;
   */
  DEPLOYMENT = 106,

  /**
   * @generated from enum value: ICON_MIGRATION = 107;
   */
  MIGRATION = 107,

  /**
   * @generated from enum value: ICON_BACKUP = 108;
   */
  BACKUP = 108,

  /**
   * @generated from enum value: ICON_RECOVERY = 109;
   */
  RECOVERY = 109,

  /**
   * Domain-based icons
   *
   * @generated from enum value: ICON_SALES = 110;
   */
  SALES = 110,

  /**
   * @generated from enum value: ICON_MARKETING = 111;
   */
  MARKETING = 111,

  /**
   * @generated from enum value: ICON_CUSTOMER_SUCCESS = 112;
   */
  CUSTOMER_SUCCESS = 112,

  /**
   * @generated from enum value: ICON_ANALYST = 113;
   */
  ANALYST = 113,

  /**
   * @generated from enum value: ICON_FINANCE = 114;
   */
  FINANCE = 114,

  /**
   * @generated from enum value: ICON_ENGINEERING = 115;
   */
  ENGINEERING = 115,

  /**
   * @generated from enum value: ICON_HUMAN_RESOURCES = 116;
   */
  HUMAN_RESOURCES = 116,

  /**
   * @generated from enum value: ICON_PRODUCT_MANAGEMENT = 117;
   */
  PRODUCT_MANAGEMENT = 117,

  /**
   * @generated from enum value: ICON_OPERATIONS = 118;
   */
  OPERATIONS = 118,

  /**
   * @generated from enum value: ICON_IT = 119;
   */
  IT = 119,

  /**
   * @generated from enum value: ICON_LEGAL = 120;
   */
  LEGAL = 120,

  /**
   * @generated from enum value: ICON_STRATEGY = 121;
   */
  STRATEGY = 121,

  /**
   * @generated from enum value: ICON_RESEARCH = 122;
   */
  RESEARCH = 122,

  /**
   * @generated from enum value: ICON_SECURITY = 123;
   */
  SECURITY = 123,

  /**
   * @generated from enum value: ICON_COMPLIANCE = 124;
   */
  COMPLIANCE = 124,

  /**
   * Communication and collaboration icons
   *
   * @generated from enum value: ICON_COLLABORATION = 125;
   */
  COLLABORATION = 125,

  /**
   * @generated from enum value: ICON_COMMUNICATION = 126;
   */
  COMMUNICATION = 126,

  /**
   * @generated from enum value: ICON_REVIEW = 127;
   */
  REVIEW = 127,

  /**
   * @generated from enum value: ICON_APPROVAL = 128;
   */
  APPROVAL = 128,

  /**
   * @generated from enum value: ICON_PRESENTATION = 129;
   */
  PRESENTATION = 129,

  /**
   * @generated from enum value: ICON_TRAINING = 130;
   */
  TRAINING = 130,

  /**
   * @generated from enum value: ICON_SUPPORT = 131;
   */
  SUPPORT = 131,

  /**
   * @generated from enum value: ICON_TROUBLESHOOTING = 132;
   */
  TROUBLESHOOTING = 132,

  /**
   * @generated from enum value: ICON_MAINTENANCE = 133;
   */
  MAINTENANCE = 133,

  /**
   * Work activity icons
   *
   * @generated from enum value: ICON_BRAINSTORMING = 134;
   */
  BRAINSTORMING = 134,

  /**
   * @generated from enum value: ICON_MEETING = 135;
   */
  MEETING = 135,

  /**
   * @generated from enum value: ICON_CODING = 136;
   */
  CODING = 136,

  /**
   * @generated from enum value: ICON_DATA_VISUALIZATION = 137;
   */
  DATA_VISUALIZATION = 137,

  /**
   * @generated from enum value: ICON_CONTRACT = 138;
   */
  CONTRACT = 138,

  /**
   * @generated from enum value: ICON_RECRUITMENT = 139;
   */
  RECRUITMENT = 139,

  /**
   * @generated from enum value: ICON_BUDGETING = 140;
   */
  BUDGETING = 140,

  /**
   * @generated from enum value: ICON_CAMPAIGN = 141;
   */
  CAMPAIGN = 141,

  /**
   * @generated from enum value: ICON_PROJECT_MANAGEMENT = 142;
   */
  PROJECT_MANAGEMENT = 142,

  /**
   * @generated from enum value: ICON_TESTING = 143;
   */
  TESTING = 143,

  /**
   * @generated from enum value: ICON_WRITE = 144;
   */
  WRITE = 144,

  /**
   * @generated from enum value: ICON_PLANNING = 145;
   */
  PLANNING = 145,

  /**
   * @generated from enum value: ICON_SCHEDULING = 146;
   */
  SCHEDULING = 146,

  /**
   * @generated from enum value: ICON_EMAIL = 147;
   */
  EMAIL = 147,

  /**
   * @generated from enum value: ICON_INTERVIEW = 148;
   */
  INTERVIEW = 148,

  /**
   * @generated from enum value: ICON_NEGOTIATION = 149;
   */
  NEGOTIATION = 149,

  /**
   * @generated from enum value: ICON_NETWORKING = 150;
   */
  NETWORKING = 150,

  /**
   * @generated from enum value: ICON_ONBOARDING = 151;
   */
  ONBOARDING = 151,

  /**
   * @generated from enum value: ICON_ROADMAP = 152;
   */
  ROADMAP = 152,

  /**
   * @generated from enum value: ICON_USER_EXPERIENCE = 153;
   */
  USER_EXPERIENCE = 153,

  /**
   * @generated from enum value: ICON_INVENTORY = 154;
   */
  INVENTORY = 154,

  /**
   * @generated from enum value: ICON_VENDOR = 155;
   */
  VENDOR = 155,

  /**
   * @generated from enum value: ICON_CUSTOMER_SERVICE = 156;
   */
  CUSTOMER_SERVICE = 156,

  /**
   * @generated from enum value: ICON_CONTENT_CREATION = 157;
   */
  CONTENT_CREATION = 157,

  /**
   * @generated from enum value: ICON_INVESTMENT = 158;
   */
  INVESTMENT = 158,

  /**
   * @generated from enum value: ICON_CONSULTING = 159;
   */
  CONSULTING = 159,

  /**
   * @generated from enum value: ICON_PENCIL_SQUARE = 160;
   */
  PENCIL_SQUARE = 160,
}

/**
 * Describes the enum common.v3.Icon.
 */
export const IconSchema: GenEnum<Icon> = /*@__PURE__*/
  enumDesc(file_common_v3_icons, 0);

